import qs from 'qs'

export const getBrowserLang = () => {
  const query = qs.parse(location.search.replace('?', ''))
  if (query.locale) {
    return query.locale
  }
  return navigator.languages
    ? navigator.languages[0]
    : (navigator.language || navigator.userLanguage)
}

export const getLocale = (lang = '') => {
  let selectedLang = ''
  lang = lang && lang.toLowerCase()
  switch (lang) {
    case 'zh':
    case 'zh-tw':
    case 'zh-hk':
      selectedLang = 'zh-tw'
      break
    case 'zh-cn':
    case 'zh-sg':
      selectedLang = 'zh-cn'
      break
    case 'fr': case 'fr-be': case 'fr-ca': case 'fr-ch': case 'fr-lu': case 'fr-fr':
      selectedLang = 'fr'
      break
    case 'de': case 'de-at': case 'de-ch': case 'de-de': case 'de-gr': case 'de-lu':
      selectedLang = 'de'
      break
    case 'nl': case 'nl-be': case 'nl-nl':
      selectedLang = 'nl'
      break
    case 'ja': case 'ja-jp':
      selectedLang = 'ja'
      break
    case 'ar': case 'ar-dz': case 'ar-bh': case 'ar-eg': case 'ar-iq': case 'ar-jo':
    case 'ar-kw': case 'ar-lb': case 'ar-ly': case 'ar-ma': case 'ar-om': case 'ar-qa':
    case 'ar-sa': case 'ar-sy': case 'ar-tn': case 'ar-ae': case 'ar-ye':
      selectedLang = 'ar'
      break
    case 'es': case 'es-ar': case 'es-bo': case 'es-cle': case 'es-co':
    case 'es-cr': case 'es-do': case 'es-ec': case 'es-es': case 'es-gt':
    case 'es-hn': case 'es-mx': case 'es-pa': case 'es-pe': case 'es-pr':
    case 'es-py': case 'es-sv': case 'es-uy': case 'es-ve':
      selectedLang = 'es'
      break
    case 'en-gb':
      selectedLang = 'en-GB'
      break
    case 'ko':
      selectedLang = 'ko'
      break
    case 'cs':
      selectedLang = 'cs'
      break
    case 'da':
      selectedLang = 'da'
      break
    case 'fi':
      selectedLang = 'fi'
      break
    case 'el':
      selectedLang = 'el'
      break
    case 'hu':
      selectedLang = 'hu'
      break
    case 'it':
      selectedLang = 'it'
      break
    case 'no':
      selectedLang = 'no'
      break
    case 'pl':
      selectedLang = 'pl'
      break
    case 'pt':
      selectedLang = 'pt'
      break
    case 'ru':
      selectedLang = 'ru'
      break
    case 'sv':
      selectedLang = 'sv'
      break
    case 'th':
      selectedLang = 'th'
      break
    case 'tr':
      selectedLang = 'tr'
      break
    case 'vi':
      selectedLang = 'vi'
      break
    case 'lt':
      selectedLang = 'lt'
      break
    case 'ms':
      selectedLang = 'ms'
      break
    case 'mn':
      selectedLang = 'mn'
      break
    case 'ro':
      selectedLang = 'ro'
      break
    case 'uk':
      selectedLang = 'uk'
      break
    case 'en': case 'en-zu': case 'en-bz': case 'en-ca': case 'en-ie': case 'en-jm':
    case 'en-nz': case 'en-ph': case 'en-za': case 'en-tt': case 'en-us':
    case 'en-zw':
    default:
      selectedLang = 'en'
      break
  }
  return selectedLang
}

export const locale = () => {
  const browserLang = getBrowserLang()
  // const browserLang = 'ar' // fake locale
  return getLocale(browserLang)
}

export const isRtl = (lang = locale()) => {
  const browserLang = lang.toLowerCase()
  switch (browserLang) {
    case 'ar':
      return true
    default:
      return false
  }
}
